import { FunctionComponent } from 'react';
import { useStream } from '@ardoq/rxbeach';
import { viewLegendHeightOffset$ } from './viewLegendHeightOffset$';

type HeightOffsetChildren = (heightOffset: number) => any;

type HeightOffsetProps = {
  children: HeightOffsetChildren;
};

export const useViewLegendSubscription = (): number =>
  useStream(viewLegendHeightOffset$, 0);

const HeightOffset: FunctionComponent<HeightOffsetProps> = ({ children }) => {
  const heightOffset = useViewLegendSubscription();

  return children(heightOffset);
};

export { HeightOffset };
